import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  locale = 'tr_TR'
}) => {
  const siteTitle = 'BrightMind Software';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - The Next Level of Intelligence`;
  const defaultDescription = 'BrightMind Software - Akıllı sistemler, gerçek çözümler. Kurumsal yazılım, yapay zeka ve ölçeklenebilir dijital sistemler konusunda uzman çözüm ortağınız.';
  const defaultKeywords = 'yazılım, software, kurumsal yazılım, enterprise software, yapay zeka, artificial intelligence, AI, dijital dönüşüm, digital transformation, web geliştirme, web development, mobil uygulama, mobile app, BrightMind, BMS';
  const siteUrl = process.env.REACT_APP_BACKEND_URL || 'https://brightmindsoftware.com';
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="author" content="BrightMind Software" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url || siteUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content={locale} />
      {image && <meta property="og:image" content={image} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      {image && <meta name="twitter:image" content={image} />}
      
      {/* Additional SEO */}
      <meta name="theme-color" content="#1e40af" />
      <meta name="msapplication-TileColor" content="#1e40af" />
    </Helmet>
  );
};

export default SEO;
